import template   from './app-message.html'
import controller from './app-message.controller'
import './app-message.styl'

let component = {
  restrict: 'E',
  bindings: {
    success: '<',
    error: '<',
    info: '<',
    delay: '<'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/app-message/app-message.component.js